import { useState } from "react";
import { useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { GetParameterByName, fetch, key, trans } from "../../lib/utils";
import FilePreviewComponent from "./filePreviewComponent";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

function FileExplorerComponent(props) {
  const [results, setResults] = useState([{ label: "root", path: "" }]);
  const [path, setPath] = useState([]);

  const [filePreviewKey, setFilePreviewKey] = useState(key());

  useEffect(() => {
    // if (path.length > 0) {
    //   window.history.pushState(
    //     { path: "?node=/" + path.join("/") },
    //     "",
    //     "?node=/" + path.join("/")
    //   );
    // } else {
    //   window.history.pushState({ path: "?node=/" }, "", "?node=/");
    // }

    let url = "getFiles.php".concat("?node=/", path.join("/"));

    fetch(window["appConfig"]()["api"](url), "GET", null, null, (resp) => {
      let _results = resp.data;

      if (path.length > 0) {
        _results.unshift({
          isParent: true,
          text: "...",
        });
      }

      setResults(_results);
    });
  }, [path]);

  const getFileIcon = (file) => {
    let ext = file.split(".");
    ext = ext[ext.length - 1].toLowerCase();

    switch (ext) {
      case "png":
        return <i className="far fa-file-image fa-2x"></i>;
        break;
      case "jpg":
        return <i className="far fa-file-image fa-2x"></i>;
        break;
      case "jpeg":
        return <i className="far fa-file-image fa-2x"></i>;
        break;
      case "tiff":
        return <i className="far fa-file-image fa-2x"></i>;
        break;
      case "pdf":
        return <i className="far fa-file-pdf fa-2x"></i>;
        break;
      case "xls":
        return <i className="far fa-file-excel fa-2x"></i>;
        break;
      case "xlsx":
        return <i className="far fa-file-excel fa-2x"></i>;
        break;
      case "doc":
        return <i className="far fa-file-word fa-2x"></i>;
        break;
      case "docx":
        return <i className="far fa-file-word fa-2x"></i>;
        break;
      case "mp4":
        return <i className="far fa-file-video fa-2x"></i>;
        break;
      case "ppt":
        return <i className="far fa-file-powerpoint fa-2x"></i>;
        break;
      case "pptx":
        return <i className="far fa-file-powerpoint fa-2x"></i>;
        break;
      case "csv":
        return <i className="far fa-file-alt fa-2x"></i>;
        break;
      case "txt":
        return <i className="far fa-file-alt fa-2x"></i>;
        break;
      case "folder":
        return <i className="far fa-folder fa-2x"></i>;
        break;
      case "zip":
        return <i className="far fa-file-archive fa-2x"></i>;
        break;
      case "parent":
        return <i className="fas fa-level-up-alt "></i>;
        break;
      default:
        return <i className="far fa-file fa-2x"></i>;
    }
  };

  return (
    <div className="w-100 h-100">
      <div className="row w-100 h-100">
        <div className="col-md-4">
          <div className="border-end">
            <div className="p-2">
              <nav aria-label="breadcrumb mb-0 small">
                <ol className="breadcrumb  mb-0">
                  <li className="breadcrumb-item">
                    <span
                      className="small"
                      role="button"
                      onClick={() => {
                        setPath([]);
                      }}
                    >
                      {trans("Home")}
                    </span>
                  </li>
                  {path.map((el, idx) => {
                    let _path = [];

                    for (var i = 0; i <= idx; i++) {
                      _path.push(el);
                    }

                    return (
                      <li className="breadcrumb-item">
                        <span
                          className="small"
                          role="button"
                          onClick={() => {
                            setPath(_path);
                          }}
                        >
                          {el}
                        </span>
                      </li>
                    );
                  })}
                </ol>
              </nav>
              <div className="small mt-2">
                {
                  results?.filter((el) => {
                    return el.leaf;
                  }).length
                }{" "}
                {trans("files have found.")}
              </div>
            </div>
            <PerfectScrollbar style={{ maxHeight: "calc(100% - 60px)" }}>
              {results?.length > 0 ? (
                <table className="table table-striped">
                  <tbody>
                    {results?.map((el) => {
                      return (
                        <tr role="button">
                          <td className="text-center" style={{ width: "2rem" }}>
                            {el.leaf
                              ? getFileIcon(el.text)
                              : el.isParent
                              ? getFileIcon("parent")
                              : getFileIcon("folder")}
                          </td>
                          <td>
                            <span
                              onClick={() => {
                                if (!el.leaf) {
                                  if (el.isParent) {
                                    let _path = [...path];

                                    _path = _path.slice(0, -1);
                                    setPath(_path);
                                  } else {
                                    setPath([...path, el.text]);
                                  }
                                } else {
                                  history.push(
                                    "?node=/" +
                                      path.join("/").concat("&file=", el.text)
                                  );
                                  // window.history.pushState(
                                  //   {
                                  //     path:
                                  //       "?node=/" +
                                  //       path
                                  //         .join("/")
                                  //         .concat("&file=", el.text),
                                  //   },
                                  //   "",
                                  //   "?node=/" +
                                  //     path.join("/").concat("&file=", el.text)
                                  // );
                                }
                                setFilePreviewKey(key());
                              }}
                              className="text-break"
                            >
                              {el.text}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <span className="p-2">{trans("No files have found")}</span>
              )}
            </PerfectScrollbar>
          </div>
        </div>
        <div className="col-md-8">
          {GetParameterByName("file") ? (
            <PerfectScrollbar
              style={{ maxHeight: "calc(100% - 180px)" }}
              key={filePreviewKey}
            >
              <FilePreviewComponent></FilePreviewComponent>
            </PerfectScrollbar>
          ) : (
            <div className="p-2 mt-2">
              {trans("Please select a file to preview it")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default FileExplorerComponent;
